import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui';
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import routes from './router'
import store from './store'
import './assets/all.css'
import './assets/style.css'
import 'lib-flexible/flexible.js'
import {request} from './API/ApiUrl'
import { setToken, getToken } from '@/utils/token'

import animated from 'animate.css'
Vue.use(animated)
Vue.use(VueRouter)
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$baseUrl = 'http://lggd.ccnu.edu.cn/'
// Vue.prototype.$baseUrl = 'http://localhost:10071/'
Vue.prototype.$http = axios
Vue.prototype.$request = request

const router = new VueRouter({
  // mode: 'history',
  base: __dirname,
  routes: routes
})

const whiteList = ['/login', '/register']

// router.beforeEach((to, from, next) => {
//   const token = getToken()
//   if (token) { // 登录
//     if (whiteList.includes(to.path)) {
//       next({ path: from.path })
//     } else {
//       setToken(token)
//       next()
//     }
//   } else {
//     if (whiteList.includes(to.path)) {
//       next()
//     } else {
//       next({
//         path: '/login', query: {
//           redirect: to.path
//         }
//       })
//     }
//   }
// })

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

